import { useCurrentUser } from '@/shared/composables/current-user'
import { tauriMode } from '@/shared/utils/import-meta'
import { getPathNameFromURL, getFullURL } from '@/shared/utils/url'

const APP_IMAGE_ORIGIN = 'http://appimage.localhost'

const isLocalOrDataUrl = (path: string) =>
  /^(blob:|data:)/i.test(path)

export const getUserAvatarUrl = (id: string) => {
  const { currentUser } = useCurrentUser()
  const pathName = `/api/user/contacts/${currentUser.value && currentUser.value?.id === id ? currentUser.value.guid : id}/photo`

  if (!pathName || isLocalOrDataUrl(pathName)) {
    return pathName
  }

  if (!tauriMode()) {
    return getFullURL(pathName)
  }

  const pathname = /^https?:/i.test(pathName)
    ? getPathNameFromURL(pathName)
    : (pathName.startsWith('/') ? pathName : `/${pathName}`)

  return `${APP_IMAGE_ORIGIN}${pathname}`
}
